'use client'

import { type ComponentProps } from 'react'
import { useFormStatus } from 'react-dom'

import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'

type Props = ComponentProps<typeof Button> & {
  pendingText?: string
  className?: string
}

export function SubmitButton({
  children,
  pendingText = 'Submitting...',
  className,
  ...props
}: Props) {
  const { pending } = useFormStatus()

  return (
    <Button
      type="submit"
      {...props}
      aria-disabled={pending}
      className={cn(
        'relative w-full focus-visible:ring-2 focus-visible:ring-primary',
        className,
      )}
    >
      {children}
      {pending && (
        <span className="ml-2 inline-flex">
          <Spinner className="size-4" />
        </span>
      )}
      <span aria-live="polite" className="sr-only" role="status">
        {pending ? 'Loading' : 'Submit form'}
      </span>
    </Button>
  )
}
